import { render, staticRenderFns } from "./relate_order_selet_popup.vue?vue&type=template&id=53f3ae90&scoped=true&"
import script from "./relate_order_selet_popup.vue?vue&type=script&lang=js&"
export * from "./relate_order_selet_popup.vue?vue&type=script&lang=js&"
import style0 from "./relate_order_selet_popup.vue?vue&type=style&index=0&id=53f3ae90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f3ae90",
  null
  
)

export default component.exports